import { Component, OnInit } from '@angular/core';
import { AppsService } from 'app/services';

@Component({
  standalone: false,
  selector: 'app-apps-info',
  templateUrl: './apps-info.component.html',
  styleUrls: ['./apps-info.component.scss']
})
export class AppsInfoComponent implements OnInit {
  constructor(public _appsService: AppsService) {}

  ngOnInit() {}
}
